import { ImageTags } from '@luxuryescapes/contract-svc-offer';

import { request } from './common';

const basePath = `${window.configs.API_HOST}/api/lab/admin-portal`;

export async function updateLabOfferImages(offerId: string, handleInBatch = false): Promise<void> {
  const batchParam = handleInBatch ? '?handleInBatch=true' : '';

  await request(`${basePath}/offers/${encodeURIComponent(offerId)}/images/tags${batchParam}`, {
    method: 'POST',
  });
}

export type UpdateSingleLabOfferImageResponse = {
  status: 200;
  data: {
    tags: ImageTags;
  };
};

export async function updateSingleLabOfferImage(cloudinaryId: string): Promise<UpdateSingleLabOfferImageResponse> {
  return await request(`${basePath}/offers/images/${encodeURIComponent(cloudinaryId)}/tags`, {
    method: 'POST',
  });
}
